import { Icon } from '@iconify/react'
import { Box, Typography } from '@mui/material'

export function LoadingText() {
  return (
    <Box
      sx={{
        px: { xs: 4, md: 12 },
        py: { xs: 6, md: 12 },
        pt: { xs: 6, md: 8 },
        backgroundColor: '#f8f8f8',
        color: '#333333',
        width: '100%',
        textAlign: 'center',
      }}
    >
      <Icon icon="tabler:search" width="85" height="85" />
      <Typography variant="body1">
        Type or paste your card list into the text box, card art will load. You
        can edit the set art and quantities of each card you want to print.
      </Typography>
    </Box>
  )
}
